import { message } from "antd";
import { ProductOpenSearchApi } from ".";

const labels = {
  "category.category_name": "Category",
  "brand.brand_name": "Brand",
  "color.color_family": "Color",
  approx_size: "Approx Size",
  finish: "Finish",
  base_material: "Base Material",
  approx_thickness: "Approx Thickness",
  sub_category: "Sub Category",
};

export function getLabel(key) {
  if (labels[key]) {
    return labels[key];
  }
  return key;
}

export async function fetchOpenSearchProducts(
  searchText,
  fieldsToSearch = {},
  pageNumber = 1,
  pageSize = 30,
  sort = "relevance",
  userType = null,
  mdView = false
) {
  const fields = {};
  Object.keys(fieldsToSearch).forEach((key) => {
    fields[key.replace("variants.", "")] = fieldsToSearch[key];
  });

  try {
    const request = {
      query_string: searchText?.replaceAll("/", "-"),
      fields_to_search: fields,
      page_number: pageNumber,
      page_size: pageSize,
      sort_by: sort,
      price_availability: true,
      md: mdView,
    };

    if (userType !== null) {
      request["user_type"] = userType;
    }

    const response = await fetch(ProductOpenSearchApi, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(request),
    });

    return response.json();
  } catch (error) {
    console.log("i-log> error", error);
    message.error("Something went wrong while fetching products");
    return null;
  }
}
